export default __webpack_public_path__ + "static/sharon-video-f548d1a64281d7e410b066af11e9d578.mp4";